<template>
  <div class="address-list flex-page">
    <div class="flex-1">
      <template v-if="list.length">
        <ul class="address-list__info flex-1">
          <van-radio-group v-model="fromAddressId" >
            <van-radio :name="item.addrId" v-for="item in list" :key="item.addrId" @click="addressClick(item)" icon-size="17px">
              <template #icon>
                <div v-if="!isneedChangeAddr"></div>
              </template>
              <template #default>
                <ul class="flex">
                  <li class="flex-1">
                    <p class="address">
                      {{ item.province + item.city + item.region + item.address }}
                    </p>

                    <span class="name">
                      <i v-if="item.defaultFlag" class="defaultFlag">默认</i>
                      {{ item.name }} &emsp;&emsp;&emsp;&emsp; {{ item.mobile }}
                    </span>
                  </li>
                  <li @click.stop="editClick(item)">
                    <van-icon name="edit" />
                  </li>
                </ul>
              </template>
            </van-radio>
            
          </van-radio-group>
          <!-- 
            
          </li> -->
        </ul>
      </template>

      <placeholder v-else-if="finished && list.length <= 0">
        <pre class="text">暂无收货地址</pre>
        <van-button class="address-list__add" @click="addAdd">添加收货地址</van-button>
      </placeholder>
    </div>

    
    <div style="padding: 12px 8px; background: #fff; display:flex" v-if="isneedChangeAddr">
      <van-button  type="primary" block round @click="addAdd" size="small" color="#D9D9D9" plain class="add-address-plain">新建收货地址</van-button>
      <van-button type="primary" block round @click="changeOrderAddress"  size="small" style="margin-left: 12px">确认修改</van-button>
    </div>
    <div style="padding: 12px 8px; background: #fff" v-else>
      <van-button v-if="list.length" type="primary" block round @click="addAdd" size="small">新建收货地址</van-button>
    </div>
  </div>
</template>

<script>
import Placeholder from '@/components/Placeholder.vue';

export default {
  components: {
    Placeholder
  },
  computed: {
    isneedChangeAddr() {
      return !!this.$route.query.orderId
    }
  },
  data() {
    return {
      setAddressInfo: {},
      fromAddressId: Number(this.$route.query.addressId),
      orderId: this.$route.query.orderId,
      status: Number(this.$route.query.status),

      active: 0,

      finished: false,

      list: []
    };
  },

  async created() {
    Telescope.trackPage({ trackId: 'zyyd-page-Address' });

    this.list = await this.$fetch.getAddressList();
    this.finished = true;
  },

  methods: {
    addressClick(item) {
      if (this.isneedChangeAddr) {
        return 
      }
      if (this.$route.query.from === 'zyyd-user-center') {
        this.editClick(item);
        return;
      }

      this.$store.commit('address/setAddressInfo', item);

      this.$router.go(-1);
      // this.adapter.goBack();
    },

    editClick(item) {
      const query = {};

      Object.keys(item).forEach((value) => {
        query[value] = String(item[value]);
      });

      this.$router.push({
        name: 'AddAddress',
        query: {
          ...query,
          ...this.$route.query
        }
      });
    },

    goAddress() {
      this.$router.go(-1);
      // this.adapter.goBack();
    },
    // 修改订单收货地址
    async changeOrderAddress() {
      const { fromAddressId, orderId, status  } = this
      const res = await this.$fetch.changeOrderAddress({
        orderId,
        addressId: fromAddressId,
        status
      })
      if (res) {
        window.setTimeout(()=> {
          this.$toast('修改成功')
        }, 300)
        this.$router.go(-1);
        
      }
    },

    addAdd() {
      this.$router.push({
        name: 'AddAddress',
        query: {
          ...this.$route.query
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.flex-page {
  min-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .flex-1 {
    flex: 1;
    overflow: auto;
  }
}
.address-list {
  height: 100%;
  .align-items {
    align-items: center;
    justify-content: center;
  }
  
  .text {
    color: @gray-7;
  }
  &__add {
    margin-top: 30px;
    background: @green;
    font-size: @font-size-md;
    font-weight: @font-weight-bold;
    color: @white;
    width: 232px;
    border-radius: 4px;
  }
 ::v-deep .van-radio {
   border-radius: 8px;
   margin: 12px 12px 0;
   background: #fff;
   .van-radio__icon--round .van-icon {
    margin-left: 14px;
    margin-right: -1px;
  }
   .van-radio__label {
     width: 100%;
   }
   
  }
 
  &__info ul {
    
    width: 100%;
    background: #fff;
    padding: 17px 10px;

    .location {
      width: 24px;
      height: 24px;
    }
    li:nth-child(1) {
      margin-right: 12px;
    }

    li {
      max-width: 100%;
      overflow: hidden;
      .address {
        font-size: @font-size-lg;
        font-weight: @font-weight-bold;
        color: @gray-8;
        margin-bottom: 12px;
      }
      .defaultFlag {
        display: inline-block;
        font-size: 10px;
        color: @white;
        background: @green;
        height: 14px;
        line-height: 14px;
        border-radius: 2px;
        padding: 0 4px;
      }
      span {
        font-size: 14px;
        color: @gray-7;
        margin-right: 10px;
        display: inherit;
      }
      .arrow {
        line-height: 64px;
        color: #999999;
      }
      .bianji {
        font-size: @font-size-bg;
        line-height: 48px;
      }
    }
    li:nth-child(2) {
      line-height: 48px;
    }
  }
  .add-address-plain {
    color: #595959 !important;
  }
}
</style>
